import dayjs from 'dayjs';

import { IHasIntersectionArgs } from './interfaces';

export const checkIntersection = ({
  bookings,
  currentBooking,
  startTime,
  endTime,
}: IHasIntersectionArgs): boolean => {
  for (const booking of bookings) {
    const bookingStart = dayjs(booking.from);
    const bookingEnd = dayjs(booking.to);

    if (currentBooking?.group && currentBooking.group === booking.group)
      continue;
    if (currentBooking?.id === booking.id) continue;
    if (bookingEnd.isBefore(startTime, 'minute')) continue;
    if (bookingEnd.isSame(startTime, 'minute')) continue;

    if (
      bookingStart.isBefore(startTime, 'minute') ||
      bookingStart.isSame(startTime, 'minute')
    ) {
      return true;
    }

    if (
      startTime.isBefore(bookingStart, 'minute') &&
      endTime?.isAfter(bookingStart, 'minute')
    ) {
      return true;
    }
  }

  return false;
};
